var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "layer3",
  transform: "translate(0 -100)"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect4208",
  d: "M5.8,0A5.728,5.728,0,0,0,0,5.679V22.716a5.728,5.728,0,0,0,5.8,5.679H23.2A5.728,5.728,0,0,0,29,22.716V5.679A5.728,5.728,0,0,0,23.2,0Zm8.3,4.04A9.868,9.868,0,0,1,22.5,8.681L24.536,7.47l.108,6.681-6.02-3.166L20.787,9.7A7.891,7.891,0,0,0,6.827,10.857a2.2,2.2,0,0,1-.082.241,1.148,1.148,0,0,1-1.43.7.974.974,0,0,1-.546-.918,2.148,2.148,0,0,1,.172-.673A9.837,9.837,0,0,1,14.1,4.04Zm-9.748,10.2,6.02,3.166L8.213,18.695a7.891,7.891,0,0,0,13.959-1.157,2.2,2.2,0,0,1,.082-.241,1.148,1.148,0,0,1,1.43-.7.974.974,0,0,1,.546.918,2.148,2.148,0,0,1-.172.673A9.9,9.9,0,0,1,6.5,19.714L4.464,20.925Z",
  transform: "translate(0 100)",
  fill: "#15289d"
}));

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28.395,
    viewBox: "0 0 29 28.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.490a5904e58dda5b615a0c9cf7ca0b32.svg";
export { ForwardRef as ReactComponent };